import React, { useState } from 'react';
import { Divider, Grid } from "@mui/material";
import Button from '../../../../components/atoms/Button/Button'
import Form from "../organisms/ModelForm";
import { ModelTypes } from "../../types/model";
import { Models } from '../../api/api-types';

type Props = {
    type: ModelTypes
    model: Models
    onSubmit: (m: Models) => Promise<void>
    onDelete?: (mID: number) => Promise<void>
}

const EditModel: React.FC<Props> = ({ type, model, onSubmit, onDelete }) => {

    const [saveLoading, setSaveLoading] = useState(false);
    const [delLoading, setDelLoading] = useState(false);

    async function handleSubmit(m: Models) {
        setSaveLoading(true);
        try {
            await onSubmit(m);
        }
        finally {
            setSaveLoading(false);
        }
    }

    return (
        <Grid container alignContent={'flex-end'} justifyContent={'center'} direction={'row'} style={{ margin: '16px 0' }}>
            <Form type={type} model={model} onSubmit={handleSubmit}>
                <Grid container alignContent={'flex-start'} justifyContent={'center'} direction={'row'} spacing={2}>
                    <Grid item xs={12}>
                        <Divider variant="fullWidth" />
                    </Grid>
                    {onDelete && <Grid item xs={6}>
                        {<Button fullWidth type={'button'} variant={'contained'} loading={delLoading} disabled={model.modelId === 0}
                            color="error" onClick={async () => {
                                setDelLoading(true);
                                await onDelete(model.modelId);
                                setDelLoading(false);
                            }}>Delete</Button>}
                    </Grid>}
                    <Grid item xs={6} >
                        <Button fullWidth type={'submit'} loading={saveLoading} variant={'contained'} color={'primary'}>Save</Button>
                    </Grid>
                </Grid>
            </Form>
        </Grid>
    );
}

export default EditModel;